export const textConfigurationTranslation = {

  // section title
  text_configuration_title: 8556,

  // predefined filters
  potentially_untranslated: 8816,

  // query filters
  text: 4312,
  original_text: 4313,

  // custom filters
  text_id: 4310,
  language: 4309,
  text_collection: 8557,
  text_set: 4311,

  // header
  add_custom_text: 8577,
  search_hits: 7474,
  search_no_hits: 8576,
  modified_texts: 8558,
  update_texts: 8559,

  // overlay
  saving_texts: 8560,
  saving_text: 8562,
  deleting_text: 8561,

  // messages
  message_texts_updated: 8563,
  no_access_to_text_configuration: 8565,
  no_access_to_code_descriptions: 8788,

  // prompt cancel
  cancel_changes: 7558,
  are_you_sure: 7460,
  undo_all: 5792,
  go_back: 7966,

  // form
  text_collections: 8620,

  text_created: 8566,
  text_updated: 8567,
  text_deleted: 8568,

  text_validation_error: 8206,
  must_be_filled_out: 5949,

  // sticky header title
  new_text: 8569,

  // sticky header buttons
  save_text_button: 8570,

  // generic button
  cancel: 3273,

  search: 7345,

  // delete confirmation popup
  delete_text_title: 8572,
  delete_text_button: 9367,
  delete_text_confirm: 8573,

  // translations
  translations_header: 8364,
  show_translations: 8393,

  copy_text_to_all: 8574,
  text_copied_to_all: 8575,

  // excel export
  excel_export_item_text: 8149,
  excel_export_confirmation: 8770,
  excel_started: 8621,
  excel_success: 8622,

  // excel import
  import_cancel: 7904,
  import_submit: 7905,
  import_choose_file: 7907,
  import_file_to_synergi_life: 7909,
  import_start: 8628,
  import_ended: 8629,
  import_failed: 8630,
  import_from_excel: 8635,
  upload_file: 8637,
  texts: 8639,
  reload_file: 8650,

  // code description
  code_descriptions_title: 4307,
  code: 5483,
  codes: 8772,
  codetable: 8651,
  description: 7278,
  long_description: 4326,
  update_descriptions: 8739,
  modified_descriptions: 8740,
  search_no_description: 8710,
  hide_inactive_codes_filter: 8582,
  message_description_updated: 8737,
  code_description_exceeded_length_hint: 8776,
  text_exceeded_length_hint: 9247,
  info_generate_aggregate_tables: 8805
};

export type TextConfigurationTranslation = {
  readonly [T in keyof typeof textConfigurationTranslation]: string
};

export const defaultMaxResults = 50;

export const maxLengthText = 4000;
